<form [ngClass]="{'needs-validation': !tributacaoNaturezaOperacao.submitted, 'was-validated': tributacaoNaturezaOperacao.submitted}"
      (ngSubmit)="onSubmitConfiguracoes()"
      #frmTributacao="ngForm"
      class="p-3">

  <!-- Informações Principais -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="tipoDeTributacaoICMS">Tipo de Tributação</label>
            <kendo-dropdownlist
              class="form-control"
              id="tipoDeTributacaoICMS"
              #tipoDeTributacaoICMS="ngModel"
              [(ngModel)]="tributacaoNaturezaOperacao.tipoDeTributacaoICMS"
              [data]="tiposDeTributacao"
              [textField]="'descricao'"
              name="tipoDeTributacaoICMS"
              placeholder="Selecione um tipo de tributação"
              required>
            </kendo-dropdownlist>
            <div class="invalid-feedback">O tipo de tributação é obrigatório</div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="cfop">CFOP Padrão</label>
            <kendo-dropdownlist
              class="form-control"
              id="cfop"
              #cfop="ngModel"
              [(ngModel)]="tributacaoNaturezaOperacao.cfop"
              [data]="cfops"
              [textField]="'descricao'"
              name="cfop"
              placeholder="Selecione um CFOP"
              required>
            </kendo-dropdownlist>
            <div class="invalid-feedback">O CFOP é obrigatório</div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label for="descricao">Descrição</label>
            <input type="text"
                   class="form-control"
                   id="descricao"
                   name="descricao"
                   #descricao="ngModel"
                   [(ngModel)]="tributacaoNaturezaOperacao.descricao"
                   placeholder="Descrição da tributação"
                   required>
            <div class="invalid-feedback">A descrição é obrigatória</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modalidades e Alíquotas -->
  <div class="card mb-3" *ngIf="['00', '20', '70', '10'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-6" *ngIf="['00', '20', '70'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
          <div class="form-group">
            <label>Base de Cálculo ICMS</label>
            <kendo-dropdownlist
              class="form-control"
              [(ngModel)]="tributacaoNaturezaOperacao.modalidadeBaseDeCalculoICMS"
              [data]="modalidadesBCICMS"
              [textField]="'descricao'"
              name="modalidadeBaseDeCalculoICMS"
              placeholder="Selecione a modalidade"
              required>
            </kendo-dropdownlist>
          </div>
        </div>

        <div class="col-12 col-md-6" *ngIf="['10', '70'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
          <div class="form-group">
            <label>Base de Cálculo ICMS ST</label>
            <kendo-dropdownlist
              class="form-control"
              [(ngModel)]="tributacaoNaturezaOperacao.modalidadeBaseDeCalculoICMSST"
              [data]="modalidadesBCIMST_ST"
              [textField]="'descricao'"
              name="modalidadeBaseDeCalculoICMSST"
              placeholder="Selecione a modalidade ST"
              required>
            </kendo-dropdownlist>
          </div>
        </div>

        <div class="col-12 col-md-4" *ngIf="['00', '20', '70'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
          <div class="form-group">
            <label>Alíquota ICMS (%)</label>
            <input type="number" class="form-control" [(ngModel)]="tributacaoNaturezaOperacao.aliquotaICMS" required>
          </div>
        </div>

        <div class="col-12 col-md-4" *ngIf="['10', '70'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
          <div class="form-group">
            <label>Alíquota ICMS ST (%)</label>
            <input type="number" class="form-control" [(ngModel)]="tributacaoNaturezaOperacao.aliquotaICMSST" required>
          </div>
        </div>

        <div class="col-12 col-md-4" *ngIf="['20', '70'].includes(tributacaoNaturezaOperacao.tipoDeTributacaoICMS?.codigo)">
          <div class="form-group">
            <label>Redução Base ICMS (%)</label>
            <input type="number" class="form-control" [(ngModel)]="tributacaoNaturezaOperacao.percentualReducaoBaseCalculoICMS" required>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Opções -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-4">
          <div class="form-check">
            <input type="checkbox"
                   class="form-check-input"
                   id="ipiCompoeBaseCalculoICMS"
                   name="ipiCompoeBaseCalculoICMS"
                   [(ngModel)]="tributacaoNaturezaOperacao.ipiCompoeBaseCalculoICMS">
            <label class="form-check-label" for="ipiCompoeBaseCalculoICMS">IPI na Base ICMS</label>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-check">
            <input type="checkbox"
                   class="form-check-input"
                   id="ipicompoeBasePISeCOFINS"
                   name="ipicompoeBasePISeCOFINS"
                   [(ngModel)]="tributacaoNaturezaOperacao.ipicompoeBasePISeCOFINS">
            <label class="form-check-label" for="ipicompoeBasePISeCOFINS">IPI na Base PIS/COFINS</label>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-check">
            <input type="checkbox"
                   class="form-check-input"
                   id="excluirICMSbasebasePISeCOFINS"
                   name="excluirICMSbasebasePISeCOFINS"
                   [(ngModel)]="tributacaoNaturezaOperacao.excluirICMSbasebasePISeCOFINS">
            <label class="form-check-label" for="excluirICMSbasebasePISeCOFINS">Excluir ICMS da Base PIS/COFINS</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Alertas e Botão -->
  <div class="mt-3">
    <div class="alert alert-success py-2 mb-2" *ngIf="mensagemSucesso" role="alert">
      <i class="fas fa-check-circle mr-1"></i> {{mensagemSucesso}}
    </div>
    <div class="alert alert-danger py-2 mb-2" *ngIf="erro" role="alert">
      <i class="fas fa-exclamation-circle mr-1"></i> {{erro}}
    </div>

    <div class="d-flex justify-content-end">
      <button type="submit" class="btn btn-primary btn-sm" [disabled]="salvando">
        <i class="fas fa-save mr-1"></i>
        {{salvando ? 'Salvando...' : 'Salvar'}}
      </button>
    </div>
  </div>

</form>
